<template>
  <div class="groupsPrdtListing">
    <section class="detail_content">
      <ul class="list_panel" v-if="availableCutpriceList.length > 0">
        <router-link
          tag="li"
          v-for="(availCutPrice,index) in availableCutpriceList"
          :key="index"
          :to="`/lucky-detail/${ availCutPrice.saleReferenceID}`"
        >
          <span class="img_wrapper">
            <img :src="availCutPrice.displayImage" alt="product-image" />
          </span>
          <p class="userdetail">
            <span class="name">{{availCutPrice.itemName}}</span>
            <span class="price">₹​ {{availCutPrice.pricingDTO.sellingPrice}}</span>
            <span
              class="location"
              v-if="availCutPrice.pricingDTO.totalPaidAmount > 0"
            >{{$t('getThisItem' , {value:availCutPrice.pricingDTO.totalPaidAmount})}}</span>
            <span class="location" v-else>{{$t('getThisFree' , {value:'FREE'})}}</span>
          </p>
        </router-link>
      </ul>
      <div
        v-if="noData && this.availableCutpriceList && this.availableCutpriceList == 0"
        class="no_record"
      >
        <p>{{$t('noProductAreThere')}}</p>
        <router-link :to="{path: '/lucky-winner-list'}" tag="div" class="winner-button">
          <img src="../../assets/images/detail/crowns.svg" />
          &nbsp; {{$t('ourWinners')}}
        </router-link>
      </div>
      <infinite-loading
        @infinite="cutPriceAvailProducts"
        spinner="circles"
        :class="{'visibilityHidden': noData}"
      >
        <template slot="no-results">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
      <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
    </section>
  </div>
</template>

<script>
import NoDataFound from "../../components/Common/NoDataFound";
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
export default {
  name: "OyeLuckyLuckyOyeListing",
  components: {
    NoDataFound
  },
  data() {
    return {
      availableCutpriceList: [],
      availableCutPriceIndex: 0,
      loading: false,
      noData: false,
      
    };
  },
  methods: {
  
    cutPriceAvailProducts($state) {
      this.loading = true;
      this.$store
        .dispatch({
          type: "getProductType",
          payload: "OYE_LUCKY?page=" + this.availableCutPriceIndex
        })
        .then(data => {
          this.loading = false;

          if (data.data.merchandiseCutPriceDTOs.length) {
            this.availableCutpriceList.push(
              ...data.data.merchandiseCutPriceDTOs
            );
            this.$store.commit("saveAvailProductCutPrice", {
              availCutPriceListData: this.availableCutpriceList,
              availCutPriceIndex: this.availableCutPriceIndex + 1
            });
            this.availableCutPriceIndex += 1;
            $state && $state.loaded();
          } else {
            this.noData = true;
            $state && $state.complete();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  mounted() {
    this.loading = true;    
  }
};
</script>
<style scoped lang="scss">
.visibilityHidden {
  visibility: hidden;
}
.list_panel li .userdetail span.price{
  font-weight: normal;
}
.no_record {
  margin: 135px 15px;
  text-align: center;
  color: #727272;
  font-family: "Hind", sans-serif;
  font-size: 1.05em;
  font-weight: 500;
  .winner-button {
    border: 1.3px solid #ff4b00;
    width: fit-content;
    margin: 15px auto;
    padding: 5px 10px;
    border-radius: 5px;
    color: #ff4b00;
    font-weight: 600;
    /* line-height: 1; */
    display: flex;
    align-items: center;
    // font-size: 1.25em;
    font-family: "Roboto", sans-serif;
  }
}

.luckydraw-btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: auto;
  display: block;
  font-weight: 600;
  text-align: center;
  background: #ff9933;
  color: #fff;
  padding: 2px 8px 0;
  border-radius: 15px;
  box-shadow: 0 0px 6px 0 rgba(0, 0, 0, 0.16);
}
</style>
    